import { CircleAlert } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { ApiError } from '@/lib/api-error';

/**
 * Erro do servidor no topo do formulário. A mensagem vem pronta do catálogo de erros do backend
 * (e os detalhes por campo, quando houver) — reescrevê-la aqui criaria duas versões da mesma frase.
 */
export function FormError({
  error,
  fallback,
  className,
}: {
  error: unknown;
  fallback: string;
  className?: string;
}) {
  if (!error) return null;
  const message =
    error instanceof ApiError ? [error.message, ...error.fieldErrors].join(' ') : fallback;
  return (
    <Alert variant="destructive" className={className}>
      <CircleAlert aria-hidden />
      <AlertDescription>{message}</AlertDescription>
    </Alert>
  );
}
